import { t } from '../../i18n';
import { cx } from '../../lib/cx';
import { useToasts } from '../../stores/toast';
import { IconClose } from '../ui/Icon';

export function Toasts() {
  const { toasts, dismiss } = useToasts();
  return (
    <div aria-live="polite" aria-atomic="false" className="fixed z-50 bottom-16 right-4 left-4 sm:left-auto flex flex-col gap-2 sm:w-[360px] pointer-events-none">
      {toasts.map((x) => (
        <div
          key={x.id}
          role={x.kind === 'error' ? 'alert' : 'status'}
          className={cx(
            'pointer-events-auto flex items-start gap-3 bg-bg border rounded-xl px-4 py-3 text-base shadow-lift',
            x.kind === 'error' ? 'border-danger' : 'border-line',
          )}
        >
          <span className={cx('flex-1', x.kind === 'error' && 'text-danger')}>{x.text}</span>
          <button type="button" aria-label={t('common.close')} className="text-lab hover:text-fg" onClick={() => dismiss(x.id)}>
            <IconClose size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
